import React, { Component } from "react"
import PropTypes from "prop-types"
import { Col, Container, Row, FormGroup, Label, Button } from "reactstrap"
import { Link } from "react-router-dom"
import { withRouter } from "../../helpers/withRouter"
import LoginCarousel from "../../components/Common/LoginCarousel"

// import images
import logo from "../../assets/images/logo.png"
import { Formik, Form, Field } from "formik"

import { loginValidation } from "../../helpers/validations"
import { Message } from "../../helpers/language_helper"
import { GetPageRoute } from "../../helpers/utils"
import footerlogo from "../../assets/images/logo_vertace.png"

import { setItemOnLocalStorage } from "../../helpers/utils"
import { QueryRequest } from "../../helpers/service_helper"
import { LoginMutation } from "./Queries"
import { ErrorMessage, SuccessMessage } from "helpers/notifications"

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      buttonAction: false,
      setPasswordShown: false,
      LoginRequestModel: {
        mobileNumber: "",
        password: "",
      },
    }
  }

  componentDidMount() {}

  AuthenticateLogin = async values => {
    // if (this.validatePage(values)) {
    // setItemOnLocalStorage("user_id", "1222")

    this.setState({
      buttonAction: true,
    })

    if (values) {
      const response = await QueryRequest(LoginMutation, values)
      //console.log("response" + JSON.stringify(response))
      // this.props.history.push("/task")

      var feed = [
        {
          id: 7,
          Name: "Feedback Section",
        },
      ]
      this.setState({
        buttonAction: false,
      })

      if (!response.data.loginUser.error) {
        setItemOnLocalStorage("user_id", response.data.loginUser.userId)
        setItemOnLocalStorage("user_token", response.data.loginUser.token)
        setItemOnLocalStorage("user_name", response.data.loginUser.name)
        if (response.data.forcePasswordChange) {
          this.props.history.push("/forcepasswordchange")
        } else {
          if (response.data.loginUser.pageAccess.length === 0) {
            setItemOnLocalStorage("PageAccess", JSON.stringify(feed))

            if (feed && feed.length > 0) {
              this.props.history.push(GetPageRoute(feed[0].id))
              window.location.reload()
            }
          } else {
            setItemOnLocalStorage(
              "PageAccess",
              JSON.stringify(response.data.loginUser.pageAccess)
            )

            setItemOnLocalStorage(
              "PageComponentAccess",
              JSON.stringify(response.data.loginUser.pageComponentAccess)
            )
          }
          if (
            response.data.loginUser.pageAccess &&
            response.data.loginUser.pageAccess.length > 0
          ) {
            this.props.history.push("/age-group")
            window.location.reload()
          }
        }
      } else {
        ErrorMessage(response.data.loginUser.error.message)
      }
    } else {
      this.props.history.push("/login")
    }
  }

  // AuthenticateUserResponse = data => {
  //   var feed = [
  //     {
  //       id: 7,
  //       Name: "Feedback Section",
  //     },
  //   ]
  //   this.setState({
  //     buttonAction: false,
  //   })

  //   if (data.result) {
  //     var useRole =
  //       data.result.Centers.length !== 0
  //         ? data.result.Centers[0].CenterType
  //         : ""
  //     var centerId =
  //       data.result.Centers.length !== 0 ? data.result.Centers[0].id : ""
  //     setItemOnLocalStorage("user_id", data.result.UserId)
  //     setItemOnLocalStorage("user_token", data.result.token)
  //     setItemOnLocalStorage("user_name", data.result.Username)
  //     setItemOnLocalStorage("role", useRole)
  //     setItemOnLocalStorage("Center_id", centerId)

  //     // sessionStorage.setItem("user_token", data.result.token)
  //     // var resultString = JSON.stringify(data.result)
  //     // sessionStorage.setItem("user_detail", resultString)
  //     // sessionStorage.setItem("user_name", data.result.Username)
  //     // sessionStorage.setItem("user_id", data.result.UserId)
  //     //   sessionStorage.setItem("role", "Hospital")

  //     if (data.result.ForcePasswordChange) {
  //       this.props.history.push("/change-password")
  //     } else {
  //       if (data.result.PageAccess.length === 0) {
  //         setItemOnLocalStorage("PageAccess", JSON.stringify(feed))

  //         if (feed && feed.length > 0) {
  //           this.props.history.push(GetPageRoute(feed[0].id))
  //           window.location.reload()
  //         }
  //       } else {
  //         setItemOnLocalStorage(
  //           "PageAccess",
  //           JSON.stringify(data.result.PageAccess)
  //         )

  //         setItemOnLocalStorage(
  //           "PageComponentAccess",
  //           JSON.stringify(data.result.PageComponentAccess)
  //         )
  //       }
  //       if (data.result.PageAccess && data.result.PageAccess.length > 0) {
  //         this.props.history.push(GetPageRoute(data.result.PageAccess[0].id))
  //         window.location.reload()
  //       }
  //     }
  //     //    this.props.history.push("/")
  //     //  window.location.reload()
  //   }
  // }
  // validatePage = values => {
  //   // Validate Call Service here
  //   return true
  // }
  togglePasswordVisiblity = () => {
    this.setState({ setPasswordShown: !this.state.setPasswordShown })
  }
  render() {
    return (
      <React.Fragment>
        <div>
          <Container fluid className="p-0">
            <Row className="no-gutters">
              <LoginCarousel />

              <Col xl={4}>
                <div className="auth-full-page-content p-md-5 p-4">
                  <div className="w-100">
                    <div className="d-flex flex-column h-100">
                      <div className="mb-md-5">
                        <Link to="#" className="d-block auth-logo">
                          <img
                            src={logo}
                            alt=""
                            height="100"
                            className="auth-logo-dark m-auto"
                          />
                        </Link>
                        <h4 className="text-center">uKiddiy</h4>
                      </div>
                      <div className="my-auto mb-5">
                        <div className="mt-0">
                          <Formik
                            initialValues={this.state.LoginRequestModel}
                            validationSchema={loginValidation}
                            onSubmit={this.AuthenticateLogin}
                            validateOnBlur={false}
                            validateOnChange={false}
                            enableReinitialize={true}
                          >
                            {({ errors, values }) => (
                              <Form>
                                <FormGroup>
                                  <h4>Login</h4>
                                  <Label for="mobileNumber" className="mt-1">
                                    Username
                                  </Label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    name="mobileNumber"
                                    placeholder={Message(
                                      "mobileNumber.placeholder"
                                    )}
                                  />
                                  {errors.mobileNumber && (
                                    <div className="invalid-feedback d-block">
                                      {errors.mobileNumber}
                                    </div>
                                  )}
                                </FormGroup>
                                <Row>
                                  <Col>
                                    <FormGroup>
                                      <Label for="userpassword">Password</Label>
                                      <Field
                                        type={
                                          this.state.setPasswordShown
                                            ? "text"
                                            : "password"
                                        }
                                        name="password"
                                        className="form-control"
                                        // placeholder={Message(
                                        //   "password.placeholder"
                                        // )}
                                      />
                                      {/* 
                                      {this.state.setPasswordShown ? (
                                        <i
                                          className="fa fa-eye password-icon"
                                          onClick={this.togglePasswordVisiblity}
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-eye-slash password-icon"
                                          onClick={this.togglePasswordVisiblity}
                                        />
                                      )} */}
                                      {errors.Password && (
                                        <div className="invalid-feedback d-block">
                                          {errors.Password}
                                        </div>
                                      )}
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <div className="mt-3">
                                  <Button
                                    color="primary"
                                    type="submit"
                                    block
                                    className={`btn-shadow btn-multiple-state ${
                                      this.state.buttonAction
                                        ? "show-spinner "
                                        : ""
                                    }`}
                                  >
                                    {" "}
                                    <span className="spinner d-inline-block">
                                      <span className="bounce1" />
                                      <span className="bounce2" />
                                      <span className="bounce3" />
                                    </span>
                                    <span className="label ">Login</span>
                                  </Button>
                                </div>
                                <Row className="mt-1 ms-1">
                                  {/* <Link to="/forgot-password">
                                    Forgot Password ?
                                  </Link> */}
                                </Row>
                              </Form>
                            )}
                          </Formik>
                        </div>
                      </div>
                    </div>
                    <div className="text-sm-center">
                      Powered by{" "}
                      <a
                        style={{
                          cursor: "pointer",
                          color: "#007bff",
                          textDecoration: "underline",
                        }}
                        href="https://vertace.com/"
                        target="blank"
                      >
                        <img
                          alt="vertace"
                          src={footerlogo}
                          style={{ width: "25px", objectFit: "contain" }}
                        />
                        Vertace
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            {/* <Col sm={6}>

              <div className="text-sm-right d-none d-sm-block">
                Powered by{" "}
                <a
                  style={{
                    cursor: "pointer",
                    color: "#007bff",
                    textDecoration: "underline",
                  }}
                  href="https://vertace.com/"
                  target="blank"
                >
                  <img
                    alt="vertace"
                    src={footerlogo}
                    style={{ width: "25px", objectFit: "contain" }}
                  />
                  Vertace
                </a>
              </div>
            </Col> */}
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

Login.propTypes = {
  t: PropTypes.any,
}

export default withRouter(Login)
